import SFError from "../models/SfError";
const useForgotPassword = () => {
  const forgotPassword = async (username) => {
    try {
      let data = {
        locale: "en-US",
        type: "client",
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      };
      const clientRawResult = await fetch(
        `${process.env.REACT_APP_OAUTH_ENDPOINT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const clientResult = await clientRawResult.json();
      // /security/otp
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/onboard/merchant-user/password/otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientResult.payload.access_token}`,
          },
          body: JSON.stringify({
            username: `${username}`,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return [null, error.json()];
      }
      const jsonResult = await result.json();
      return [jsonResult, null];
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError.json()];
    }
  };

  const submitOTP = async (username, refCode, otp) => {
    try {
      let data = {
        locale: "en-US",
        type: "client",
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      };
      const clientRawResult = await fetch(
        `${process.env.REACT_APP_OAUTH_ENDPOINT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const clientResult = await clientRawResult.json();

      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/security/otp/verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientResult.payload.access_token}`,
          },
          body: JSON.stringify({
            username: `${username}`,
            ref_code: refCode,
            otp_code: otp,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return [null, error.json()];
      }
      const jsonResult = await result.json();
      return [jsonResult, null];
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError.json()];
    }
  };

  const addNewPassword = async (username, password, otp) => {
    try {
      let data = {
        locale: "en-US",
        type: "client",
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      };
      const clientRawResult = await fetch(
        `${process.env.REACT_APP_OAUTH_ENDPOINT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const clientResult = await clientRawResult.json();

      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/onboard/merchant-user/password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientResult.payload.access_token}`,
          },
          body: JSON.stringify({
            username: `${username}`,
            password: `${password}`,
            secret: `${otp}`,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return [null, error.json()];
      }
      const jsonResult = await result.json();
      return [jsonResult, null];
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError.json()];
    }
  };
  return { forgotPassword, addNewPassword, submitOTP };
};

export default useForgotPassword;
